import React, { useState } from 'react';
import { ArrowRight, Star, CheckCircle2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';


const Hero: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="relative bg-[#011E26] text-white overflow-hidden min-h-screen flex items-center">


      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1436491865332-7a61a109cc05?ixlib=rb-4.0.3&auto=format&fit=crop&w=2074&q=80"
          alt="International Airport terminal with airplanes - representing global travel and mobility"
          className="w-full h-full object-cover opacity-30 mix-blend-overlay"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#011E26] via-[#011E26]/95 to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-8 pt-24 pb-12 w-full flex flex-col lg:flex-row items-center gap-12 lg:gap-0">

        {/* Content Side */}
        <div className="w-full lg:w-3/5 space-y-8">

          <div className="inline-flex items-center gap-2 mb-2 bg-[#009B8F]/10 px-3 py-1 rounded border border-[#009B8F]/30">
            <div className="w-2 h-2 rounded-full bg-[#009B8F] animate-pulse"></div>
            <span className="text-xs font-bold tracking-widest text-[#009B8F] uppercase">Global Mobility Infrastructure</span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl leading-tight font-serif font-light tracking-tight">
            Nex Overseas <br />
            <span className="text-[#009B8F] font-normal italic text-3xl md:text-4xl lg:text-5xl block mt-4">
              "The all-In-One Operating System for Your Global Career"
            </span>
          </h1>

          <p className="text-slate-400 font-light text-lg md:text-xl max-w-xl leading-relaxed uppercase tracking-wide">
            Admissions | Coaching | Visa | Travel & Transport | Advisory
          </p>


          <div className="flex flex-wrap gap-6 pt-8 text-xs font-bold tracking-widest uppercase text-slate-500">
            <div className="flex items-center gap-2">
              <CheckCircle2 size={16} className="text-[#009B8F]" /> 20+ Countries
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle2 size={16} className="text-[#009B8F]" /> Experts Advice
            </div>
          </div>
        </div>

        {/* Floating Card */}
        <div className="w-full lg:w-2/5 pl-0 lg:pl-12 overflow-hidden">
          <div className="bg-[#00151a]/80 backdrop-blur-md border border-[#009B8F]/30 p-10 rounded-sm shadow-2xl relative transform lg:rotate-1 hover:rotate-0 transition-transform duration-500 group">
            <div className="absolute -top-3 -right-3 w-16 h-16 border-t-4 border-r-4 border-[#009B8F] rounded-tr-xl opacity-50 group-hover:opacity-100 transition-opacity"></div>

            <h3 className="text-2xl font-serif text-white mb-8 flex items-center gap-2">
              AI Powered Journey
              <span className="h-px flex-grow bg-slate-700 ml-4"></span>
            </h3>

            <ul className="space-y-4">
              {[
                { label: '1. Admissions Support', service: 'admissions' },
                { label: '2. English Prep Hub', service: 'english-prep' },
                { label: '3. Visa Compliance Hub', service: 'immigration' },
                { label: '4. Arrival Planner', service: 'travel' },
                { label: '5. AI Accommodation Matcher', service: 'accommodation' }
              ].map((item) => (
                <li
                  key={item.label}
                  onClick={() => navigate(`/eligibility?service=${item.service}`)}
                  className="flex justify-between items-center border-b border-slate-700/50 pb-4 group/item cursor-pointer hover:bg-white/5 transition-all px-2 rounded"
                >
                  <span className="text-slate-300 font-sans text-lg group-hover/item:text-white transition-colors">{item.label}</span>
                  <ArrowRight size={18} className="text-[#009B8F] transition-all transform group-hover/item:translate-x-1" />
                </li>
              ))}
            </ul>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Hero;